var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return __webpack_require__.e("vendors-node_modules_pivx-shield_node_modules_pivx-shield-rust-multicore_pivx_shield_rust_js").then(next);
};